import { useCallback } from 'react';

import type { ShareChannel } from '#src/app/pages/psf/share/shared/types';
import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import { useGenPetitionUrl } from './genUrl';
import { useGetPetitionShareUrlSuffix } from './pathSuffix';

const MEDIUM_MAPPING: Partial<Record<ShareChannel, string>> = {
	facebookMessenger: 'facebook',
	copy: 'copylink',
};

export function useGetShareUrl(): ShareActionsOptions<ShareChannel>['getUrl'] {
	const genUrl = useGenPetitionUrl();
	const getDefaultPathSuffix = useGetPetitionShareUrlSuffix();

	return useCallback(
		(channel) => {
			const medium = MEDIUM_MAPPING[channel] || channel;
			const pathSuffix = getDefaultPathSuffix(channel);
			return genUrl({ medium, pathSuffix });
		},
		[genUrl, getDefaultPathSuffix],
	);
}
